import api from './api';

export interface ScheduleBlockDto {
  id: string;
  dayOfWeek: number;
  startLocal: string;
  endLocal: string;
  teacherTimezone: string;
  label?: string;
}

export interface UpsertScheduleBlockRequest {
  dayOfWeek: number;
  startLocal: string;
  endLocal: string;
  teacherTimezone?: string;
  label?: string;
}

export const scheduleService = {
  async list(): Promise<ScheduleBlockDto[]> {
    const res = await api.get<ScheduleBlockDto[]>('/teacher/schedule-blocks');
    return res.data;
  },

  async create(body: UpsertScheduleBlockRequest): Promise<ScheduleBlockDto> {
    const res = await api.post<ScheduleBlockDto>('/teacher/schedule-blocks', body);
    return res.data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/teacher/schedule-blocks/${id}`);
  },
};
